<button class="actions-bar__button" type="button" onclick="document.getElementById('fileInput').click();" [disabled]="this.disabled" >
    <div [class]="this.badgeClass + ' ' + this.badgeColor" [hidden]="!this.badgeActive">{{this.badge}}</div>
    <span [class]="this.colorClass"><i [class]="this.iconClass"></i></span>
    <span class="actions-bar__button-label">{{this.text}}</span>
    <input id="fileInput" type="file" style="display:none;" (change)="this.onFileChange($event)" />
</button>
